<template>
  <Header />
  <section class="page-body">
    <VersionTip />
    <!-- <Breadcrumb /> -->
    <slot></slot>
  </section>
</template>

<script setup>
  import Header from '@/components/header';
  import VersionTip from '@/components/versionTip';
</script>

<style scoped>
  @import "index.less";
</style>
